var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMenuReports = function SvgMenuReports(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "59F2D262-0A7E-4F7A-8243-0D73D077860A")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design-System",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Design-system",
    transform: "translate(-91.000000, -1240.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-reports",
    transform: "translate(91.000000, 1240.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFE78F",
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.352,17.5 C15.84,17.5 16.252,17.354 16.588,17.062 C16.924,16.77 17.092,16.252 17.092,15.508 C17.092,14.764 16.924,14.246 16.588,13.954 C16.252,13.662 15.84,13.516 15.352,13.516 C14.848,13.516 14.43,13.662 14.098,13.954 C13.766,14.246 13.6,14.764 13.6,15.508 C13.6,16.26 13.768,16.78 14.104,17.068 C14.44,17.356 14.856,17.5 15.352,17.5 Z M15.496,22.048 C15.728,22.048 15.9,21.948 16.012,21.748 L16.012,21.748 L20.356,13.852 C20.396,13.788 20.416,13.74 20.416,13.708 C20.416,13.668 20.392,13.634 20.344,13.606 C20.296,13.578 20.232,13.564 20.152,13.564 L20.152,13.564 L19.792,13.564 C19.56,13.564 19.388,13.66 19.276,13.852 L19.276,13.852 L14.92,21.748 C14.888,21.804 14.872,21.856 14.872,21.904 C14.872,21.944 14.894,21.978 14.938,22.006 C14.982,22.034 15.048,22.048 15.136,22.048 L15.136,22.048 L15.496,22.048 Z M15.352,16.624 C14.904,16.624 14.68,16.252 14.68,15.508 C14.68,15.196 14.726,14.936 14.818,14.728 C14.91,14.52 15.088,14.416 15.352,14.416 C15.616,14.416 15.794,14.52 15.886,14.728 C15.978,14.936 16.024,15.196 16.024,15.508 C16.024,16.252 15.8,16.624 15.352,16.624 Z M19.924,22.084 C20.42,22.084 20.836,21.938 21.172,21.646 C21.508,21.354 21.676,20.836 21.676,20.092 C21.676,19.348 21.508,18.83 21.172,18.538 C20.836,18.246 20.42,18.1 19.924,18.1 C19.428,18.1 19.014,18.246 18.682,18.538 C18.35,18.83 18.184,19.348 18.184,20.092 C18.184,20.844 18.35,21.364 18.682,21.652 C19.014,21.94 19.428,22.084 19.924,22.084 Z M19.924,21.208 C19.476,21.208 19.252,20.836 19.252,20.092 C19.252,19.364 19.476,19 19.924,19 C20.188,19 20.366,19.104 20.458,19.312 C20.55,19.52 20.596,19.78 20.596,20.092 C20.596,20.836 20.372,21.208 19.924,21.208 Z",
    id: "%",
    fill: "#EBB900",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-5",
    stroke: "#FFFEFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: 18,
    cy: 18,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,18 C8,23.5228475 12.4771525,28 18,28 C23.5228475,28 28,23.5228475 28,18 C28,12.4771525 23.5228475,8 18,8",
    id: "Path",
    stroke: "#EBB900",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenuReports, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu-reports.19a86a6a.svg";
export { ForwardRef as ReactComponent };